import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { matchRoutes, RouteObject, useLocation } from 'react-router-dom';

interface RouteObjectWithTitle extends RouteObject {
    title?: string;
    children?: RouteObjectWithTitle[];
}

const useDocumentTitle = (allRoutes: RouteObjectWithTitle[]) => {
    const location = useLocation();
    const intl = useIntl();

    useEffect(() => {
        const matchedRoutes = matchRoutes(allRoutes, location);
        const currentRoute = matchedRoutes?.[matchedRoutes.length - 1]?.route as RouteObjectWithTitle;
        const title = currentRoute?.title || '';
        if (title) {
            document.title = `${intl.formatMessage({ id: title })} | Rubricae Dashboard`;
        } else {
            document.title = '| Rubricae Dashboard';
        }
    }, [location.pathname, allRoutes]);
};

export default useDocumentTitle;
